<template>
  <PaginationWrapper
    :page="page"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <LocationTariffsListSearchOptions
      @onSearch="handleSearch"
      slot="search-options"
    />
    <LocationTariffsListTable slot="table" />
  </PaginationWrapper>
</template>

<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import LocationTariffsListTable from '@/components/sections/tariffs/LocationTariffsListTable';
import LocationTariffsListSearchOptions from '@/components/sections/tariffs/LocationTariffsListSearchOptions';

export default {
  name: 'LocationTariffsList',
  components: {
    PaginationWrapper,
    LocationTariffsListTable,
    LocationTariffsListSearchOptions,
  },
  data() {
    return {
      query: {},
      page: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      // this.totalCount = await this.$store.dispatch('storeTariffs', {
      //   query: this.query,
      //   page: this.page
      // });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: this.query,
          type: 'locationTariffs',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', {
              type: 'locationTariffs',
            }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `locationTariffs-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', {
              type: 'locationTariffs',
            }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'locationTariffs' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
